const title = 'centrics'

export default function getPageTitle(pageTitle) {
  return `${title}`
}
